import { Component, Input, OnInit } from '@angular/core';
import { ConsumptionInterface } from '../../models/consumption.interface';

@Component({
  selector: 'app-consumption-details',
  templateUrl: './consumption-details.component.html',
  styleUrls: ['./consumption-details.component.css'],
  standalone: false
})
export class ConsumptionDetailsComponent implements OnInit {

  @Input()
  consumption: ConsumptionInterface;
  alternatedBackground: boolean = true;
  constructor() {}

  ngOnInit() {
    this.alternatedBackground  = true;
  }

  setBackgroundColor(index: number) {
    if (index % 2 === 0) {
      this.alternatedBackground = true;
    } else {
      this.alternatedBackground = false;
    }
    return this.alternatedBackground;
  }
}
